import Tag from '../ui/Tag';
import Button from '../ui/Button';
import styles from './TagFilter.module.css';

interface TagFilterProps {
  allTags: string[];
  activeTags: string[];
  onToggleTag: (tag: string) => void;
  onClearAll: () => void;
  filteredCount: number;
  totalCount: number;
}

export default function TagFilter({
  allTags,
  activeTags,
  onToggleTag,
  onClearAll,
  filteredCount,
  totalCount,
}: TagFilterProps) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.label}>FILTER</span>
        <span className={styles.count}>
          {filteredCount} / {totalCount} archives
        </span>
        {activeTags.length > 0 && (
          <Button variant="ghost" size="sm" onClick={onClearAll} className={styles.clearBtn}>
            CLEAR
          </Button>
        )}
      </div>
      <div className={styles.tags}>
        {allTags.map((tag) => (
          <button
            key={tag}
            className={`${styles.tagBtn} ${activeTags.includes(tag) ? styles.active : ''}`}
            onClick={() => onToggleTag(tag)}
          >
            <Tag variant={activeTags.includes(tag) ? 'cyan' : 'default'} size="sm">
              {tag}
            </Tag>
          </button>
        ))}
      </div>
    </div>
  );
}
